'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbsenteeBidModalLoader = require('./AbsenteeBidModal/AbsenteeBidModalLoader');

var _AbsenteeBidModalLoader2 = _interopRequireDefault(_AbsenteeBidModalLoader);

var _AddCreditCardModalLoader = require('./AddCreditCard/AddCreditCardModalLoader');

var _AddCreditCardModalLoader2 = _interopRequireDefault(_AddCreditCardModalLoader);

var _AddSearchAlertModalLoader = require('./AddSearchAlertModal/AddSearchAlertModalLoader');

var _AddSearchAlertModalLoader2 = _interopRequireDefault(_AddSearchAlertModalLoader);

var _AutoPopModalContainer = require('../Modals/AutoPopModal/AutoPopModalContainer');

var _AutoPopModalContainer2 = _interopRequireDefault(_AutoPopModalContainer);

var _CompleteAccountModalLoader = require('./CompleteAccountModal/CompleteAccountModalLoader');

var _CompleteAccountModalLoader2 = _interopRequireDefault(_CompleteAccountModalLoader);

var _ConfirmPasswordModalLoader = require('./ConfirmPasswordModal/ConfirmPasswordModalLoader');

var _ConfirmPasswordModalLoader2 = _interopRequireDefault(_ConfirmPasswordModalLoader);

var _reactRedux = require('react-redux');

var _ConsignmentConfirmModalLoader = require('./ConsignmentConfirmModal/ConsignmentConfirmModalLoader');

var _ConsignmentConfirmModalLoader2 = _interopRequireDefault(_ConsignmentConfirmModalLoader);

var _DownloadMobileModalLoader = require('./DownloadMobileModal/DownloadMobileModalLoader');

var _DownloadMobileModalLoader2 = _interopRequireDefault(_DownloadMobileModalLoader);

var _ForgotPasswordModalLoader = require('./ForgotPasswordModal/ForgotPasswordModalLoader');

var _ForgotPasswordModalLoader2 = _interopRequireDefault(_ForgotPasswordModalLoader);

var _modal = require('../../redux/modules/modal');

var _HealthcheckModalLoader = require('./HealthcheckModal/HealthcheckModalLoader');

var _HealthcheckModalLoader2 = _interopRequireDefault(_HealthcheckModalLoader);

var _InstallFlashModalLoader = require('./InstallFlashModal/InstallFlashModalLoader');

var _InstallFlashModalLoader2 = _interopRequireDefault(_InstallFlashModalLoader);

var _ItemDescriptionModalLoader = require('./ItemDescriptionModal/ItemDescriptionModalLoader');

var _ItemDescriptionModalLoader2 = _interopRequireDefault(_ItemDescriptionModalLoader);

var _LoginModalLoader = require('./LoginModal/LoginModalLoader');

var _LoginModalLoader2 = _interopRequireDefault(_LoginModalLoader);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RegisterForCatalogModalLoader = require('./RegisterForCatalogModal/RegisterForCatalogModalLoader');

var _RegisterForCatalogModalLoader2 = _interopRequireDefault(_RegisterForCatalogModalLoader);

var _RetractBidModalLoader = require('./RetractBidModal/RetractBidModalLoader');

var _RetractBidModalLoader2 = _interopRequireDefault(_RetractBidModalLoader);

var _SendSellerMessageModalLoader = require('./SendSellerMessageModal/SendSellerMessageModalLoader');

var _SendSellerMessageModalLoader2 = _interopRequireDefault(_SendSellerMessageModalLoader);

var _SignUpModalContainer = require('./SignUpModal/SignUpModalContainer');

var _SignUpModalContainer2 = _interopRequireDefault(_SignUpModalContainer);

var _SignUpPasswordModalLoader = require('./SignUpPasswordModal/SignUpPasswordModalLoader');

var _SignUpPasswordModalLoader2 = _interopRequireDefault(_SignUpPasswordModalLoader);

var _SubmitConsignmentModalLoader = require('./SubmitConsignmentModal/SubmitConsignmentModalLoader');

var _SubmitConsignmentModalLoader2 = _interopRequireDefault(_SubmitConsignmentModalLoader);

var _TermsModalLoader = require('./TermsModal/TermsModalLoader');

var _TermsModalLoader2 = _interopRequireDefault(_TermsModalLoader);

var _UpdatePasswordModalLoader = require('./UpdatePasswordModal/UpdatePasswordModalLoader');

var _UpdatePasswordModalLoader2 = _interopRequireDefault(_UpdatePasswordModalLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modals = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        openModal: (0, _modal.getOpenModal)(state)
    };
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(Modals, _Component);

    function Modals() {
        (0, _classCallCheck3.default)(this, Modals);
        return (0, _possibleConstructorReturn3.default)(this, (Modals.__proto__ || (0, _getPrototypeOf2.default)(Modals)).apply(this, arguments));
    }

    (0, _createClass3.default)(Modals, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return this.props.openModal !== nextProps.openModal;
        }
    }, {
        key: 'render',
        value: function render() {
            var openModal = this.props.openModal;


            return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_AutoPopModalContainer2.default, {}), (0, _jsx3.default)(_SignUpModalContainer2.default, {}), openModal === 'ABSENTEE_BID' && (0, _jsx3.default)(_AbsenteeBidModalLoader2.default, {}), openModal === 'ADD_CREDIT_CARD' && (0, _jsx3.default)(_AddCreditCardModalLoader2.default, {}), openModal === 'ADD_SEARCH_ALERT' && (0, _jsx3.default)(_AddSearchAlertModalLoader2.default, {}), openModal === 'CHANGE_PASSWORD' && (0, _jsx3.default)(_UpdatePasswordModalLoader2.default, {}), openModal === 'LOGIN' && (0, _jsx3.default)(_LoginModalLoader2.default, {}), openModal === 'RETRACT_BID' && (0, _jsx3.default)(_RetractBidModalLoader2.default, {}), openModal === 'SEND_SELLER_MESSAGE' && (0, _jsx3.default)(_SendSellerMessageModalLoader2.default, {}), openModal === 'SEND_SELLER_CONSIGNMENT_MESSAGE' && (0, _jsx3.default)(_SubmitConsignmentModalLoader2.default, {}), openModal === 'SET_PASSWORD' && (0, _jsx3.default)(_SignUpPasswordModalLoader2.default, {}), openModal === 'COMPLETE_ACCOUNT' && (0, _jsx3.default)(_CompleteAccountModalLoader2.default, {}), openModal === 'CONFIRM_PASSWORD' && (0, _jsx3.default)(_ConfirmPasswordModalLoader2.default, {}), openModal === 'CONFIRM_CONSIGNMENT' && (0, _jsx3.default)(_ConsignmentConfirmModalLoader2.default, {}), openModal === 'DOWNLOAD_MOBILE' && (0, _jsx3.default)(_DownloadMobileModalLoader2.default, {}), openModal === 'FORGOT_PASSWORD' && (0, _jsx3.default)(_ForgotPasswordModalLoader2.default, {}), openModal === 'HEALTHCHECK' && (0, _jsx3.default)(_HealthcheckModalLoader2.default, {}), openModal === 'INSTALL_FLASH' && (0, _jsx3.default)(_InstallFlashModalLoader2.default, {}), openModal === 'ITEM_DESCRIPTION' && (0, _jsx3.default)(_ItemDescriptionModalLoader2.default, {}), openModal === 'REGISTER_FOR_AUCTION' && (0, _jsx3.default)(_RegisterForCatalogModalLoader2.default, {}), openModal === 'TERMS' && (0, _jsx3.default)(_TermsModalLoader2.default, {}));
        }
    }]);
    return Modals;
}(_react.Component)) || _class);
exports.default = Modals;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/Modals.js
// module id = pxDK
// module chunks = 57